// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"608015e0","29":"dce5181f","170":"fed7ea5f","338":"db1601f4","544":"eb8e03f6","624":"b35c06d0","887":"3d1c348b"}[chunkId] + ".chunk.js";
};